import { Entity } from "src/app/core/utils/entity";

export abstract class DeleteAudienceEntity extends Entity {
    constructor(
        public id: string
    ) {
        super();
    }
}